import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {DashboardWrapperComponent} from "./dashboard-wrapper.component";
import {UserDefinedDashboardComponent} from "./userDefined/user-defined-dashboard.component";
import {DashboardComponent} from "./dashboard.component";


const routes: Routes = [
    {path: 'view', pathMatch: 'full', component: DashboardWrapperComponent},
    {path: 'view/:dashboard', component: DashboardWrapperComponent},
    {path: 'user', component: UserDefinedDashboardComponent},
    {path: 'utilisateur', component: UserDefinedDashboardComponent},
    {path: ':dashboardName', pathMatch: 'full', component: DashboardWrapperComponent},
    {path: '', pathMatch: 'full', redirectTo: 'view'},


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class DashboardRoutingModule {}
